import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import Article from './Article'

interface Props {
  field: any
  form: any
}

const IllustratedTexts = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { field, form } = props

  const buildArticleTemplate = () => {
    return {
      text_title: '',
      text_content: '',
      image_id: null,
      image_url: null,
      image_name: '',
      image_alt: '',
    }
  }

  const initArticlesContent = () => {
    return field?.value?.content && !_.isEmpty(field.value.content)
      ? field.value.content
      : { articles: [buildArticleTemplate()] }
  }

  const [articlesContent, setArticlesContent] = useState(initArticlesContent)
  const [articles, setArticles] = useState(articlesContent.articles)

  useEffect(() => {
    form.setFieldValue(field.name, {
      ...field.value,
      content: articlesContent,
    })
  }, [articlesContent])

  useEffect(() => {
    setArticlesContent({
      ...articlesContent,
      articles: [...articles],
    })
  }, [articles])

  const addArticle = () => {
    const newArticles = _.cloneDeep(articles)
    newArticles.push(buildArticleTemplate())
    setArticles(newArticles)
  }

  return (
    <Wrapper>
      <h2>Articles</h2>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.illustratedTexts.sectionTitle')}
              </label>
            </Col>
            <Col span={24}>
              <Input
                placeholder="Titre"
                defaultValue={field?.value?.title || ''}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    title: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.illustratedTexts.sectionSubTitle')}
              </label>
            </Col>
            <Col span={24}>
              <Input
                placeholder="Sous titre"
                defaultValue={field?.value?.subtitle || ''}
                onBlur={e =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    subtitle: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              {articles.map((article: any, index: any) => (
                <Row key={`${article.text_title}.${index}`}>
                  <Col span={24} className={'article-edit'}>
                    <Article
                      setArticles={setArticles}
                      articles={articles}
                      index={index}
                    />
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Col>
        <Col span={2}>
          <button
            type="button"
            onClick={() => {
              addArticle()
            }}
          >
            {t('ficheComparative.illustratedTexts.addArticle')}
          </button>
        </Col>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`

export default IllustratedTexts
